import React from 'react';
import { useNavigate } from 'react-router-dom';

// Full-width "Back" control shown at the bottom of a page so users don't have
// to scroll back up to navigate away. Pass `to` for a specific destination;
// omit it to go back one step in history.
export default function BackButtonBottom({ to, label = 'Back' }) {
  const navigate = useNavigate();
  return (
    <button
      type="button"
      onClick={() => (to ? navigate(to) : navigate(-1))}
      className="w-full mt-8 p-3 rounded-xl border-[1.5px] border-slate-200 bg-white cursor-pointer font-semibold text-body"
    >
      ← {label}
    </button>
  );
}